import React from 'react';

const Notfound = () => {
    return (
        <div className="flex justify-center items-center h-screen bg-gray-900 text-white">
            <div className="text-center">
                <h1 className="text-5xl font-bold mb-4">404</h1>
                <p className="text-lg">Oops! Page not found.</p>
            </div>
        </div>
    );
}

export default Notfound;
